import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";

import Toolbar from "@material-ui/core/Toolbar";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Typography from "@material-ui/core/Typography";
import mosymLogo from "./icons/mosymLogo.svg";
import Avatar from "@material-ui/core/Avatar";

import OrgIcon from "./icons/org.png";
import { ReactComponent as HelpIcon } from "./icons/help.svg";
import { ReactComponent as SettingsIcon } from "./icons/settings.svg";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import NotificationsIcon from "@material-ui/icons/Notifications";
import Badge from "@material-ui/core/Badge";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
// import SettingsIcon from '@material-ui/icons/Settings';
import {
  userProfileData,
  orgProfileData,
  userLogout,
} from "../../../../containers/actions/userActions";
import { fetchUnreadCount } from "../../containers/actions/common/notificationsAction";
import ToolTip from "../common/models/buttons/ToolTip";
import { ReactComponent as RaiseTicketIcon } from "./icons/jira_icon.svg";
import { smlUrl, sponsorHelpUrlRedirect, raiseTicketUrlRedirect } from "../../../../utils/config";
import axios from "axios";

const useStyles = makeStyles((theme) => ({
  menuButton: {
    marginRight: 15,
  },
  flexAlign: {
    display: "flex",
    alignItems: "center",
  },
  flexEnd: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  pathName: {
    display: "inline",
    fontWeight: 500,
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  mosymLogo: {
    marginRight: 15,
    height: "40px",
    [theme.breakpoints.down("xs")]: {
      width: 150,
    },
  },
  rightList: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  accountMenu: {
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  buttonHover: {
    "&:hover": { backgroundColor: "transparent" },
  },
}));

const Header = (props) => {
  const { handleDrawerOpen } = props;
  const [ecosystem, setEcosystems] = useState([]);
  const classes = useStyles();
  const location = useLocation();
  const dispatch = useDispatch();

  let userAvatar = useSelector((state) =>
    state.user.userDetails.profile_pic
      ? state.user.userDetails.profile_pic
      : "../../failedpath"
  );
  let userName = useSelector((state) =>
    state.user.userDetails.full_name
      ? state.user.userDetails.full_name.toUpperCase()
      : ""
  );

  let orgLogo = useSelector((state) => state.user.orgDetails.org_logo);
  const unreadCount = useSelector((state) => state.pcmp.common.notifications.unreadCount);
  // Gate the bell icon + unread-count fetch on the notificationsDashboard screen variable
  const notificationsDashboardAccess = useSelector(
    (state) =>
      state.pcmp.common.accessControl?.screensAccess?.data
        ?.notificationsDashboard?.screenAccess === true
  );

  useEffect(() => {
    dispatch(userProfileData());
    dispatch(orgProfileData());
    axios
      .get(`${smlUrl}/sml/getUserEcosystems`)
      .then((res) => {
        if (res.data.status) {
          if (
            res.data.userEcosystems &&
            Array.isArray(res.data.userEcosystems)
          ) {
            setEcosystems(res.data.userEcosystems);
            if (res.data.userEcosystems.length > 0 && res.data.userEcosystems[0].ecosystem_name) {
              localStorage.setItem("ecosystem_name", res.data.userEcosystems[0].ecosystem_name);
            }
          }
        }
      })
      .catch((err) => console.log(err));
  }, [dispatch]);

  // Fetch unread count only if the user has access to the notifications dashboard screen.
  // Fires once accessControl.screensAccess resolves (flag flips from undefined → true).
  useEffect(() => {
    if (notificationsDashboardAccess) {
      dispatch(fetchUnreadCount());
    }
  }, [dispatch, notificationsDashboardAccess]);

  let history = useHistory();
  let path = location.pathname.split("/");

  const [anchorEl, setAnchorEl] = useState(null);

  const currentPath = path[6];
  const project = path[7];

  const pathName = (name) => {
    switch (name) {
      case "projectsdashboard": {
        if (project === "structuredData") {
          return "Projects Dashboard - Reports - Structured Data";
        } else if (project === "pendingitems") {
          return "Projects Dashboard - Analytics - Pending Items";
        } else if (project === "FTE-Budget") {
          return "Projects Dashboard - Analytics - FTE/Budget";
        } else {
          return "Projects Dashboard";
        }
      }
      case "project":
        return "Compound ID - " + `${project}`;
      case "tasksDashboard":
        return "Tasks Dashboard";
      case "dashboard":
        return "Dashboard";
      case "executivedashboard":
        return "Executive Dashboard";
      case "purchaseorderManagement":
        return "Collaboration - Purchase Order";
      case "inactivePOs": {
        if (project === "poDetails") {
          return "PO Details";
        }
        return "Collaboration - Delivered/Deleted POs";
      }
      case "poAlerts":
        return "PO Alerts";
      case "purchaseorders": {
        if (project === "lineitems") {
          return "Purchase Order Details";
        } else if (project === "purchaseOrderAuditReport") {
          return "View PO History";
        } else {
          return "Purchase Order";
        }
      }

      case "lineitems":
        return "Line Items";
      case "fgBatches":
        return "Collaboration - Batch Execution";
      // return 'Batch execution';
      case "goodsReceipt":
        return "Collaboration - Goods Receipt";
      case "genealogyReports":
        return "Genealogy Reports";
      case "GRNReceipts":
        return "RM/PM Deliveries";
      case "shortFalls":
        return "Shortfall Reports";
      case "schedule agreements":
        // return "Purchase Orders/Scheduling Agreements";
        return "Delivery Schedules";
      case "forecastSchedule":
        return "Forecast Schedule";
      case "reports":
        return "Audit Trail";
      case "ecosystemusers":
        return "Network Users";
      case "userProfile":
        return "My Profile";
      case "orgprofile":
        return "Organization Profile";
      case "CMOs":
        return "Configurations - CMOs";
      case "addCMO":
        return "Configurations - CMOs";
      case "products":
        return "Configurations - Product Details";
      case "viewProduct":
        return "Configurations - Product Details";
      case "editProduct":
        return "Configurations - Product Details";
      case "addProduct":
        return "Configurations - Product Details";
      case "branddetails":
        return "Configuration - Brand Details";
      case "managereasoncodes":
        return "Configuration - Manage Reason Codes";
      case "sponsornetwork":
        return "Configuration - Sponsor Network";
      case "materialdetails":
        return "Configuration - Material Details";
      case "managemembers":
        return "Network Users";
      case "rolesandaccess":
        return "User Management - Manage Roles";
      case "teamMembers":
        return "User Management - Manage Users";
      case "inventoryStatus":
        return "Collaboration - Inventory Status";
      case "notifications":
        return "Notifications";
      case "settings":
        return "Settings";
      case "help":
        return "Help";
      case "switch ecosystem":
        return "Switch Ecosystems";
      case "sasl":
        return "Delivery Schedule Details";
      case "sa-audit-reports":
        return "Analytics - Batch History Reports";
      case "pofulfilmentdashboard":
        return "Analytics - PO Fulfilment";
      case "averageOTIFReport":
        return "Average OTIF Trend";
      case "quality events":
        return "Quality Events";
      case "sitesAndResources":
        return "Sites and Resources";
      case "viewComponentAllocation":
        return "View Component Allocation";
      case "viewDetailedComponentAllocation":
        return "Component Allocation";
      case "viewBatchComponentAllocation":
        return "View RM/PM Lots (Planned and Actual)";
      case "esda":
        return "Pre-emptive Analysis Dashboard";
      default:
        return "Mosymphony";
    }
  };

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleLogout = () => {
    dispatch(userLogout(history));
  };

  const HELP_AGENT_URL = sponsorHelpUrlRedirect;
  const RAISE_TICKET_URL = raiseTicketUrlRedirect;

  const handleRaiseTicket = () => {
    const url = `${RAISE_TICKET_URL}`;
    try {
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      window.open(url, "_blank");
    }
  };

  const handleOpenNewWindow = () => {
    try {
      const link = document.createElement("a");
      link.href = HELP_AGENT_URL;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      // Fallback when programmatic link click is restricted (e.g. some popup blockers)
      window.open(HELP_AGENT_URL, "_blank");
    }
  };

  return (
    <Toolbar>
      <Grid container alignItems="center" justify="space-between">
        <Grid item xs={10} md={8} className={classes.flexAlign}>
          <IconButton
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={classes.menuButton}
            disableFocusRipple
            disableTouchRipple
          >
            <MenuIcon />
          </IconButton>
          <img src={mosymLogo} alt="logo" className={classes.mosymLogo} />
          <Typography
            variant="h5"
            noWrap
            color="textPrimary"
            className={classes.pathName}
          >
            {pathName(currentPath)}
          </Typography>
        </Grid>
        <Grid item xs={2} md={4} className={classes.flexEnd}>
          <Grid container alignItems="center" justify="flex-end">
            {notificationsDashboardAccess && (
              <ToolTip title={"Notifications"} placement="bottom-end" arrow>
                <IconButton
                  disableFocusRipple
                  disableRipple
                  disableTouchRipple
                  classes={{ root: classes.buttonHover }}
                  component={Link}
                  to={`/${path[1]}/${path[2]}/${path[3]}/${path[4]}/${path[5]}/notifications`}
                >
                  <Badge badgeContent={unreadCount} color="error" max={99}>
                    <NotificationsIcon style={{ color: "#313645" }} />
                  </Badge>
                </IconButton>
              </ToolTip>
            )}
            <ToolTip title={"Raise a Ticket"} placement="bottom-end" arrow>
              <IconButton
                disableFocusRipple
                disableRipple
                disableTouchRipple
                classes={{
                  root: classes.buttonHover,
                }}
                className={classes.rightList}
                onClick={handleRaiseTicket}
              >
                <RaiseTicketIcon style={{ width: 24, height: 24 }} />
              </IconButton>
            </ToolTip>
            <ToolTip title={"Help"} placement="bottom-end" arrow>
              {localStorage.collabType === 'CMO' ?
                <IconButton
                  disableFocusRipple
                  disableRipple
                  disableTouchRipple
                  classes={{
                    root: classes.buttonHover,
                  }}
                  className={classes.rightList}
                  component={Link}
                  to={`/${path[1]}/${path[2]}/${path[3]}/${path[4]}/${path[5]}/help`}
                >
                  <HelpIcon fill="#313645" />
                </IconButton>
                :
                <IconButton
                  disableFocusRipple
                  disableRipple
                  disableTouchRipple
                  classes={{
                    root: classes.buttonHover,
                  }}
                  className={classes.rightList}
                  onClick={handleOpenNewWindow}
                >
                  <HelpIcon fill="#313645" />
                </IconButton>
              }

            </ToolTip>

            <ToolTip title={"Settings"} placement="bottom-end" arrow>
              <IconButton
                disableFocusRipple
                disableRipple
                disableTouchRipple
                classes={{
                  root: classes.buttonHover,
                }}
                className={classes.rightList}
                component={Link}
                to={`/${path[1]}/${path[2]}/${path[3]}/${path[4]}/${path[5]}/settings`}
              >
                <SettingsIcon />
              </IconButton>
            </ToolTip>

            {ecosystem.length > 1 && (
              <ToolTip title={"Switch Network"} placement="bottom-end" arrow>
                <IconButton
                  disableFocusRipple
                  disableRipple
                  disableTouchRipple
                  classes={{
                    root: classes.buttonHover,
                  }}
                  className={classes.rightList}
                  component={Link}
                  to={`/switch-ecosystem?return_url=${location.pathname}`}
                >
                  {/* <OrgIcon fill='#313645' /> */}
                  <img src={OrgIcon} alt="org" />
                </IconButton>
              </ToolTip>
            )}
            {orgLogo && (
              <div
                style={{ height: 64, width: 150 }}
                className={classes.rightList}
              >
                <img
                  src={orgLogo}
                  alt="org_logog"
                  style={{ height: "100%", width: "100%" }}
                />
              </div>
            )}
            <IconButton
              disableFocusRipple
              disableRipple
              disableTouchRipple
              classes={{
                root: classes.buttonHover,
              }}
              onClick={handleOpenMenu}
            >
              <Avatar alt={userName} src={userAvatar} />
              <ArrowDropDownIcon />
            </IconButton>
            <Menu
              id="account-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              getContentAnchorEl={null}
            >
              <MenuItem
                component={Link}
                onClick={handleClose}
                to={`/${path[1]}/${path[2]}/${path[3]}/${path[4]}/${path[5]}/userProfile`}
              >
                My Account &amp; Profile
              </MenuItem>
              <MenuItem
                className={classes.accountMenu}
                component={Link}
                onClick={handleClose}
                to={`/switch-ecosystem?return_url=${location.pathname}`}
              >
                Switch Network
              </MenuItem>
              <MenuItem
                className={classes.accountMenu}
                component={Link}
                to={`/${path[1]}/${path[2]}/${path[3]}/${path[4]}/${path[5]}/settings`}
              >
                Settings
              </MenuItem>
              <MenuItem
                className={classes.accountMenu}
                onClick={() => {
                  if (localStorage.collabType !== 'CMO') {
                    handleClose()
                    handleOpenNewWindow();
                  }
                }}
              >
                Help
              </MenuItem>
              <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </Menu>
          </Grid>
        </Grid>
      </Grid>
    </Toolbar>
  );
};

export default Header;